export const SORT_OPTIONS = {
  VOLUME_24H: '24hr Volume',
  TOTAL_VOLUME: 'Total Volume',
  LIQUIDITY: 'Liquidity',
  NEWEST: 'Newest',
  ENDING_SOON: 'Ending Soon',
  COMPETITIVE: 'Competitive',
} as const;

export const FREQUENCY_OPTIONS = {
  ALL: 'All',
  DAILY: 'Daily',
  WEEKLY: 'Weekly',
  MONTHLY: 'Monthly',
} as const;

export const FILTER_STATUS = {
  ACTIVE: 'Active',
  RESOLVED: 'Resolved',
  // CLOSED: 'Closed',
} as const;

export const DEFAULT_FILTERS = {
  SORT_BY: SORT_OPTIONS.VOLUME_24H,
  FREQUENCY: FREQUENCY_OPTIONS.ALL,
  STATUS: FILTER_STATUS.ACTIVE,
} as const;

export const SORT_FILTER_OPTIONS = Object.values(SORT_OPTIONS).map((opt) => ({
  label: opt,
  value: opt,
}));

export const FREQUENCY_FILTER_OPTIONS = Object.values(FREQUENCY_OPTIONS).map((opt) => ({
  label: opt,
  value: opt,
}));

export const STATUS_FILTER_OPTIONS = Object.values(FILTER_STATUS).map((opt) => ({
  label: opt,
  value: opt,
}));
